var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-select autocompletex", class: { "w-100": _vm.block } },
    [
      _c(
        "label",
        { staticClass: "vs-select--label", attrs: { for: _vm.name } },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-select",
            {
              class: { "v-select-danger": _vm.danger, "w-100": _vm.block },
              attrs: {
                name: _vm.name,
                value: _vm.optionSelected,
                options: _vm.listOptions,
                disabled: _vm.isDisabled
              },
              on: { input: _vm.onInput },
              scopedSlots: _vm._u([
                {
                  key: "spinner",
                  fn: function() {
                    return [
                      _vm.officesState.loading
                        ? _c("div", {
                            staticClass: "vs__spinner",
                            staticStyle: {
                              "border-left-color": "rgba(88,151,251,0.71)"
                            },
                            style: { opacity: _vm.officesState.loading ? 1 : 0 }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("template", { slot: "no-options" }, [
                _vm._v(" no hay oficinas para el criterio de búsqueda ")
              ])
            ],
            2
          ),
          _vm.withFilters && _vm.filters.length > 1
            ? _c("vs-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Limpiar filtros",
                    expression: "'Limpiar filtros'"
                  }
                ],
                staticClass: "cursor-pointer ml-2",
                attrs: { icon: "delete", size: "medium", color: "danger" },
                on: { click: _vm.cleanFilters }
              })
            : _vm._e(),
          _vm.withFilters
            ? _c("vs-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Filtrar oficinas",
                    expression: "'Filtrar oficinas'"
                  }
                ],
                staticClass: "cursor-pointer ml-2",
                attrs: {
                  icon: "filter_list",
                  size: "medium",
                  color: "secondary"
                },
                on: {
                  click: function($event) {
                    return _vm.$refs.officefilters.show()
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.danger
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger v-enter-to",
              staticStyle: { height: "19px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.dangerText) + " ")
              ])
            ]
          )
        : _vm._e(),
      _vm.withFilters
        ? _c(
            "b-modal",
            {
              ref: "officefilters",
              attrs: {
                title: "Filtros",
                centered: "",
                "no-close-on-backdrop": "",
                "hide-footer": "",
                size: "lg"
              }
            },
            [
              _c("OfficeFilters", {
                attrs: {
                  currentFilters: _vm.filters,
                  clearCategory: _vm.clearCategory,
                  clearSubcategory: _vm.clearSubcategory
                },
                on: {
                  category: function($event) {
                    _vm.regionId = $event
                  },
                  subcategory: function($event) {
                    _vm.serviceId = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }